import styled from 'styled-components'
import { Layout } from 'antd'
import { colors } from 'Common/constants'

export const StyledHeader = styled(Layout.Header)`
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/Header/styled.js